<template>
  <div class="page-content">
    <b-container fluid>
      <create-job-form/>
    </b-container>
  </div>
</template>

<script>
  import CreateJobForm from '../components/jobs/CreateJobForm.vue';

  export default {
    components: {
      CreateJobForm,
    },
  };
</script>

<style scoped>

</style>
